import { render, staticRenderFns } from "./AxForgotPassword.vue?vue&type=template&id=22e49742&scoped=true&"
import script from "./AxForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./AxForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./AxForgotPassword.vue?vue&type=style&index=0&id=22e49742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e49742",
  null
  
)

export default component.exports